import React, { useState } from 'react';
import { menuUtil } from 'modules/common';
import {
  Menu,
  MenuItem,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import { RemovePlanSetModal } from 'modules/components/layer17';
export type PlanSetMenuProps = menuUtil.IBaseMenuProps & {};

export const FC = (props: PlanSetMenuProps) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  return (
    <>
      <Menu
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log('MENU CLICKED');
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        id={props.id}
        open={props.open}
        anchorEl={props.anchorEl ?? null}
        onClose={() => props.handleClose()}
      >

        <MenuItem
          onClick={(e) => {
            console.log('MENU ITEM CLICKED');
            e.preventDefault();
            e.stopPropagation();
            setIsVisible(() => true);
          }}
        >
          <Stack
            direction='row'
            columnGap='.5rem'
          >
            <CustomIcon.large.FC
              icon='DELETE'
              stroke={theme.palette.primary.main}
            />
            <Typography
              variant='menuItem'
            >
              Remove Plan Set
            </Typography>
          </Stack>
        </MenuItem>
      </Menu>
      {isVisible && (
        <RemovePlanSetModal.FC
          id={props.id}
          handleClose={props.handleClose}
          isVisible={isVisible}
        />
      )}
    </>
  );
};

